/**
 * Encodes a URL query parameter value using Base64.
 * Makes filter values non-human-readable in the browser address bar.
 */
export const encodeParam = (value: string): string => {
  try {
    return btoa(encodeURIComponent(value));
  } catch {
    return value;
  }
};

/**
 * Decodes a Base64-encoded URL query parameter value.
 * Returns the original value unchanged if decoding fails (graceful fallback).
 */
export const decodeParam = (encoded: string): string => {
  try {
    return decodeURIComponent(atob(encoded));
  } catch {
    return encoded; // fallback: treat as plain text (backward compat)
  }
};

/**
 * Encodes a comma-separated list of values (e.g. "CAT001,CAT002").
 */
export const encodeParamList = (values: string[]): string =>
  values.map(encodeParam).join(",");

/**
 * Decodes a comma-separated list of encoded values.
 */
export const decodeParamList = (encoded: string): string[] =>
  encoded.split(",").map(decodeParam);
